import React, { useState, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { updateInfoData } from "../../redux/reducers";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  InputBase,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  CircularProgress,
} from "@mui/material";
import {
  Search as SearchIcon,
  CalendarToday,
  ClearAll,
  Close as CloseIcon,
} from "@mui/icons-material";
import { translateText } from "../../translations/translationService";
import {
  insertMovimientosMo,
  fetchAsignacionPorUsuario,
  fetchAsignacionPorUsuarioFinalizadas,
  fullDataPiece,
} from "../../services/ConnectDataBase";
import { SCREEN_IDS } from "../FullComponent.js";
import {
  getCurrentLocalISODateTime,
  extraerMinutos,
  formatearFecha,
  esHoy,
  getArrayInfoDataUpdate,
} from "../../services/Functions.js";
import { useNavigation } from "@react-navigation/native";
import { MUI_COLORS, STATUS_COLORS, BACKGROUND_COLORS, BORDER_COLORS, TEXT_COLORS } from "../../style/colors.js";
import AppDialog from "../Common/ui/AppDialog";
import AppButton from "../Common/ui/AppButton";
import AppSelect from "../Common/ui/AppSelect";
import AppTextField from "../Common/ui/AppTextField";

export default function AsignarPorUsuarioModal({
  open,
  onClose,
  usuariosTaller,
  listData,
  onAsignarSeleccionadas,
  lang,
}) {
  const [team, setTeam] = useState("");
  const [usuario, setUsuario] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [moSeleccionadas, setMoSeleccionadas] = useState([]);
  const [page, setPage] = useState(0);
  const [isAssigning, setIsAssigning] = useState(false);
  const rowsPerPage = 25;
  const dispatch = useDispatch();
  const navigation = useNavigation();

  const [assignedStatus, setAssignedStatus] = useState([]);
  const [assignedStatusFinalizado, setAssignedStatusFinalizado] = useState([]);
  const [expandedUser, setExpandedUser] = useState(null);
  const [totalProceso, setTotalProceso] = useState(0);
  const [modalVisible, setModalVisible] = useState(true);
  const hoyStr = new Date().toISOString().split("T")[0];

  const [fechaSeleccionada, setFechaSeleccionada] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [mostrarSoloFinalizadas, setMostrarSoloFinalizadas] = useState(false);

  const saveMovimientoMo = async () => {
    const proceso = procesoPorEquipo[team];

    for (const moKey of moSeleccionadas) {
      const mo = listData.find((item) => item.key === moKey);
      if (!mo) continue;

      const tiempoUnitario = mo.tiemposProceso?.[proceso] || 0;
      const duracion = tiempoUnitario * mo.cantidad;

      const data = {
        mo: mo.mo,
        team,
        usuario,
        tipo: proceso,
        codigo: mo.po,
        fecha_asignacion: getCurrentLocalISODateTime(),
        duracion,
      };
      try {
        await insertMovimientosMo(
          "insertMovimientosMo",
          SCREEN_IDS.GENERAL,
          data
        );
      } catch (error) {
        console.error("Error al insertar en asignaciones_mo:", error);
      }
    }
  };

  const handleFechaChange = async (nuevaFecha) => {
    setFechaSeleccionada(nuevaFecha);
    if (mostrarSoloFinalizadas) {
      await updateAssignedStatusFinalizadas(nuevaFecha);
    }
  };

  useEffect(() => {
    const unsubscribe = navigation.addListener("focus", () => {
      if (open) {
        setModalVisible(true);
      }
    });

    return unsubscribe;
  }, [navigation, open]);

  useEffect(() => {
    if (open) {
      setModalVisible(true);
    }
  }, [open]);

  const asignadoHoyPorUsuario = useMemo(() => {
    const sums = {};

    assignedStatus.forEach((mo) => {
      if (esHoy(mo.fecha_asignacion)) {
        const min = extraerMinutos(mo.duracion);
        sums[mo.usuario] = (sums[mo.usuario] || 0) + min;
      }
    });

    assignedStatusFinalizado.forEach((mo) => {
      const raw =
        typeof mo.fecha_asignacion === "object" && mo.fecha_asignacion.date
          ? mo.fecha_asignacion.date
          : mo.fecha_asignacion;
      if (raw && raw.startsWith(hoyStr)) {
        const min = extraerMinutos(mo.duracion);
        sums[mo.usuario] = (sums[mo.usuario] || 0) + min;
      }
    });

    return sums;
  }, [assignedStatus, assignedStatusFinalizado]);

  useEffect(() => {
    if (open) {
      updateAssignedStatus();
      updateAssignedStatusFinalizadas(fechaSeleccionada);
    }
  }, [open]);

  useEffect(() => {
    if (fechaSeleccionada && mostrarSoloFinalizadas) {
      updateAssignedStatusFinalizadas(fechaSeleccionada);
    }
  }, [fechaSeleccionada, mostrarSoloFinalizadas]);

  const validateData = async (code) => {
    if (!code) {
      return;
    }
    try {
      const dataOk = await fullDataPiece(code.mo, 2);
      if (dataOk) {
        const infoData = getArrayInfoDataUpdate(dataOk);

        dispatch(updateInfoData(infoData));
        return dataOk;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmitCode = async (code) => {
    try {
      const fullData = await validateData(code);

      if (code) {
        if (fullData && fullData.mo) {
          setModalVisible(false);
          navigation.navigate("Info", { data: fullData, fromDetalle: true });
        } else {
          console.log("La propiedad 'mo' no existe en fullData.");
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const updateAssignedStatus = async () => {
    const assignedData = await fetchAsignacionPorUsuario(
      "fetchAsignacionPorUsuario",
      SCREEN_IDS.GENERAL
    );
    setAssignedStatus(assignedData || []);
  };

  const updateAssignedStatusFinalizadas = async (fecha) => {
    const assignedData = await fetchAsignacionPorUsuarioFinalizadas(
      "fetchAsignacionPorUsuarioFinalizadas",
      SCREEN_IDS.GENERAL,
      fecha
    );
    setAssignedStatusFinalizado(assignedData || []);
  };

  const usuariosFiltrados = useMemo(() => {
    return usuariosTaller.filter((u) => u.cod_team === team);
  }, [usuariosTaller, team]);

  const equiposPermitidos = [
    "Sacador de fuego",
    "Pulido",
    "Baños",
    "Grabado laser",
  ];

  const procesoPorEquipo = {
    "Sacador de fuego": "REPASO",
    Pulido: "PULIDO",
    Baños: "BAÑOS",
    "Grabado laser": "GRABADO",
  };

  const resumenAgrupado = useMemo(() => {
    const agrupado = {};

    if (mostrarSoloFinalizadas) {
      assignedStatusFinalizado.forEach((item) => {
        if (!agrupado[item.team]) agrupado[item.team] = {};
        if (!agrupado[item.team][item.usuario])
          agrupado[item.team][item.usuario] = [];
        agrupado[item.team][item.usuario].push({
          ...item,
          estado: "finalizado",
        });
      });
    } else {
      assignedStatus.forEach((item) => {
        if (!agrupado[item.team]) agrupado[item.team] = {};
        if (!agrupado[item.team][item.usuario])
          agrupado[item.team][item.usuario] = [];

        const estado = esHoy(item.fecha_asignacion)
          ? "activo_hoy"
          : "activo_anterior";
        agrupado[item.team][item.usuario].push({
          ...item,
          estado,
        });
      });

      const hoy = new Date().toISOString().split("T")[0];
      if (fechaSeleccionada === hoy) {
        assignedStatusFinalizado.forEach((item) => {
          if (!agrupado[item.team]) agrupado[item.team] = {};
          if (!agrupado[item.team][item.usuario])
            agrupado[item.team][item.usuario] = [];
          agrupado[item.team][item.usuario].push({
            ...item,
            estado: "finalizado",
          });
        });
      }
    }

    return agrupado;
  }, [
    assignedStatus,
    assignedStatusFinalizado,
    mostrarSoloFinalizadas,
    fechaSeleccionada,
  ]);

  const procesarTextoQR = (texto) => {
    const patron = /\d{6}-\d{3}/g;
    const codigos = texto.match(patron) || [];
    return codigos.join(" ");
  };

  const moFiltradas = useMemo(() => {
    if (!searchValue.trim()) return listData;

    const textoProcesado = procesarTextoQR(searchValue.trim());

    if (!textoProcesado) {
      const searchTerms = searchValue
        .trim()
        .split(" ")
        .map((s) => s.trim());
      return listData.filter((item) =>
        searchTerms.includes(item.mo.replace("'", "-"))
      );
    }

    const searchTerms = textoProcesado
      .split(" ")
      .map((s) => s.trim())
      .filter((s) => s.length > 0);

    return listData.filter((item) =>
      searchTerms.includes(item.mo.replace("'", "-"))
    );
  }, [searchValue, listData]);

  const moPaginadas = useMemo(() => {
    const start = page * rowsPerPage;
    const end = start + rowsPerPage;
    return moFiltradas.slice(start, end);
  }, [moFiltradas, page]);

  const handleSearchChange = (e) => {
    let valor = e.target.value.replace(/'/g, "-");
    const valorSinComas = valor.replace(/,/g, "");
    const valorConComas = valorSinComas.replace(/(.{10})/g, "$1,");

    setSearchValue(valorConComas);
    setPage(0);
  };

  const toggleMo = (moKey) => {
    const isSelected = moSeleccionadas.includes(moKey);
    const mo = listData.find((item) => item.key === moKey);
    const proceso = procesoPorEquipo[team];
    const tiempoUnitario = mo?.tiemposProceso?.[proceso] || 0;
    const tiempoTotal = tiempoUnitario * mo.cantidad; // ✅ CORREGIDO: tiempo unitario × cantidad

    if (isSelected) {
      setMoSeleccionadas((prev) => prev.filter((key) => key !== moKey));
      setTotalProceso((prev) => prev - tiempoTotal);
    } else {
      setMoSeleccionadas((prev) => [...prev, moKey]);
      setTotalProceso((prev) => prev + tiempoTotal);
    }
  };

  const handleFiltrarPorFecha = async () => {
    setMostrarSoloFinalizadas(true);
    await updateAssignedStatusFinalizadas(fechaSeleccionada);
  };

  const handleQuitarFiltros = async () => {
    setMostrarSoloFinalizadas(false);
    await updateAssignedStatus();
    await updateAssignedStatusFinalizadas(
      new Date().toISOString().split("T")[0]
    );
  };

  const handleAsignar = async () => {
    if (isAssigning) return;
    setIsAssigning(true);
    try {
      await onAsignarSeleccionadas(usuario, moSeleccionadas, team);
      await saveMovimientoMo();
      await updateAssignedStatus();

      setMoSeleccionadas([]);
      setTotalProceso(0);
    } catch (error) {
      console.error("Error al asignar:", error);
    } finally {
      setIsAssigning(false);
    }
  };

  const renderEstadoMo = (mo) => {
    switch (mo.estado) {
      case "finalizado":
        return (
          <Chip
            label='Finalizado'
            size='small'
            color='success'
            sx={{ mx: 1 }}
          />
        );
      case "activo_hoy":
        return (
          <Chip
            label={formatearFecha(mo.fecha_asignacion) || "Hoy"}
            size='small'
            color='info'
            sx={{ mx: 1 }}
          />
        );
      case "activo_anterior":
        return (
          <Chip
            label={formatearFecha(mo.fecha_asignacion)}
            size='small'
            color='warning'
            sx={{ mx: 1 }}
          />
        );
      default:
        console.warn("Estado desconocido:", mo.estado);
        return null;
    }
  };

  const finalizarMoManualmente = async (mo) => {
    try {
      const data = {
        team: mo.team,
        usuario: mo.usuario,
        mo: mo.mo,
        finalizado: true,
        fecha_finalizacion: getCurrentLocalISODateTime(), // Agregar fecha de finalización
      };

      await insertMovimientosMo(
        "insertMovimientosMo",
        SCREEN_IDS.GENERAL,
        data
      );

      await updateAssignedStatus();
      if (mostrarSoloFinalizadas) {
        await updateAssignedStatusFinalizadas(fechaSeleccionada);
      }

      console.log(`MO ${mo.mo} marcada como finalizada para ${mo.usuario}`);
    } catch (error) {
      console.error("Error al finalizar MO manualmente:", error);
    }
  };

  return (
    <AppDialog
      open={open && modalVisible}
      onClose={onClose}
      title={translateText("Asignar por usuario", lang)}
      maxWidth="xl"
      actions={null}
    >
      <Box sx={{ display: "flex", gap: 2, height: "78vh", minHeight: 520 }}>
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            p: 2,
            borderRadius: 2,
            border: `1px solid ${BORDER_COLORS.PRIMARY}`,
            backgroundColor: BACKGROUND_COLORS.CARD,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}>

          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <AppSelect
              value={team}
              onChange={(e) => {
                setTeam(e.target.value);
                setUsuario("");
                setMoSeleccionadas([]);
                setTotalProceso(0);
              }}
              displayEmpty
              fullWidth>
              <MenuItem value=''>
                <em>{translateText("Seleccione equipo", lang)}</em>
              </MenuItem>
              {[
                ...new Set(
                  usuariosTaller
                    .map((u) => u.cod_team)
                    .filter((cod) => equiposPermitidos.includes(cod))
                ),
              ].map((teamName) => (
                <MenuItem key={teamName} value={teamName}>
                  {teamName}
                </MenuItem>
              ))}
            </AppSelect>

            <AppSelect
              value={usuario}
              onChange={(e) => {
                setUsuario(e.target.value);
                setMoSeleccionadas([]);
                setTotalProceso(0);
              }}
              displayEmpty
              fullWidth
              disabled={!team}>
              <MenuItem value=''>
                <em>{translateText("Seleccione usuario", lang)}</em>
              </MenuItem>
              {usuariosFiltrados.map((u) => (
                <MenuItem key={u.key} value={u.name}>
                  {u.name}
                </MenuItem>
              ))}
            </AppSelect>
          </Box>

          <Typography variant='body2' sx={{ fontWeight: "bold", mb: 1 }}>
            {translateText("Tiempo para asignar:", lang)}{" "}
            <strong>{procesoPorEquipo[team] || "..."}</strong>:{" "}
            <span style={{ color: MUI_COLORS.PRIMARY }}>{totalProceso} min</span>
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <InputBase
              value={searchValue}
              onChange={handleSearchChange}
              placeholder='Buscar MO... (escanee códigos QR)'
              sx={{ flex: 1, background: BACKGROUND_COLORS.SECONDARY, px: 2, borderRadius: 1 }}
            />
            <IconButton>
              <SearchIcon />
            </IconButton>
          </Box>

          <Box sx={{ overflowY: "auto", flexGrow: 1, minHeight: 0, mb: 2 }}>
            <Table size='small' stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>T. Total</TableCell>
                  <TableCell>T. Uni</TableCell>
                  <TableCell>MO</TableCell>
                  <TableCell>Cantidad</TableCell>
                  <TableCell>Referencia</TableCell>
                  <TableCell>Observaciones</TableCell>
                  <TableCell align='right'>+</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {moPaginadas.map((mo) => (
                  <TableRow key={mo.key}>
                    <TableCell>
                      {team &&
                      procesoPorEquipo[team] &&
                      mo.tiemposProceso?.[procesoPorEquipo[team]] !== undefined
                        ? mo.tiemposProceso[procesoPorEquipo[team]] *
                          mo.cantidad
                        : "--"}
                    </TableCell>
                    <TableCell>
                      {team &&
                      procesoPorEquipo[team] &&
                      mo.tiemposProceso?.[procesoPorEquipo[team]] !== undefined
                        ? mo.tiemposProceso[procesoPorEquipo[team]]
                        : "--"}
                    </TableCell>
                    <TableCell>{mo.mo}</TableCell>
                    <TableCell>
                      {mo.cantidad != null
                        ? Number(mo.cantidad).toFixed(2)
                        : "0.00"}
                    </TableCell>
                    <TableCell>{mo.referencia}</TableCell>
                    <TableCell>{mo.observaciones || "..."}</TableCell>
                    <TableCell align='right'>
                      <AppButton
                        onClick={() => toggleMo(mo.key)}
                        sx={{
                          minWidth: 40,
                          px: 1.5,
                          backgroundColor: moSeleccionadas.includes(mo.key)
                            ? STATUS_COLORS.ERROR
                            : STATUS_COLORS.SUCCESS,
                          borderColor: "transparent",
                          "&:hover": {
                            backgroundColor: moSeleccionadas.includes(mo.key)
                              ? STATUS_COLORS.ERROR_LIGHT
                              : STATUS_COLORS.SUCCESS,
                          },
                        }}>
                        {moSeleccionadas.includes(mo.key) ? "-" : "+"}
                      </AppButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 1,
            }}>
            <Typography variant='body2'>
              Página {page + 1} de {Math.ceil(moFiltradas.length / rowsPerPage)}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: "auto",
            }}>
            <Box>
              <AppButton
                variantType='secondary'
                disabled={page === 0}
                onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                sx={{ mr: 1 }}>
                Anterior
              </AppButton>
              <AppButton
                variantType='secondary'
                disabled={(page + 1) * rowsPerPage >= moFiltradas.length}
                onClick={() => setPage((prev) => prev + 1)}>
                Siguiente
              </AppButton>
            </Box>

            <Box>
              <AppButton onClick={onClose} variantType='secondary' sx={{ mr: 2 }}>
                {translateText("Cerrar", lang)}
              </AppButton>
              <AppButton
                onClick={handleAsignar}
                disabled={
                  !usuario || moSeleccionadas.length === 0 || isAssigning
                }
                startIcon={isAssigning ? <CircularProgress size={20} /> : null}>
                {isAssigning
                  ? translateText("Asignando...", lang)
                  : translateText("Asignar", lang)}
              </AppButton>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            width: 400,
            p: 3,
            height: "80vh",
            bgcolor: BACKGROUND_COLORS.CARD,
            border: `1px solid ${BORDER_COLORS.MEDIUM}`,
            borderRadius: 2,
            boxShadow: 6,
            display: "flex",
            flexDirection: "column",
          }}>
          <Box sx={{ p: 2, borderBottom: `1px solid ${BORDER_COLORS.SECONDARY}` }}>
            <Typography variant='h6' sx={{ mb: 2, fontWeight: "bold" }}>
              {translateText("Resumen de asignaciones", lang)}
            </Typography>

            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
              <AppTextField
                type='date'
                value={fechaSeleccionada}
                onChange={(e) => handleFechaChange(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <CalendarToday sx={{ mr: 1, color: MUI_COLORS.PRIMARY }} />
                  ),
                }}
                sx={{
                  flex: 1,
                }}
              />
              <AppButton
                variantType='secondary'
                onClick={handleFiltrarPorFecha}
                disabled={mostrarSoloFinalizadas}>
                Filtrar
              </AppButton>
            </Box>

            {mostrarSoloFinalizadas && (
              <AppButton
                startIcon={<ClearAll />}
                onClick={handleQuitarFiltros}
                sx={{ mb: 2 }}
                fullWidth>
                Quitar Filtros
              </AppButton>
            )}

            <Typography variant='body2' sx={{ color: TEXT_COLORS.SECONDARY, mb: 1 }}>
              {mostrarSoloFinalizadas
                ? `Finalizadas del ${formatearFecha(fechaSeleccionada)}`
                : "Activas + Finalizadas de hoy"}
            </Typography>
          </Box>

          <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
            {Object.keys(resumenAgrupado).length === 0 && (
              <Typography variant='body2' sx={{ color: TEXT_COLORS.DISABLED }}>
                {translateText("No hay asignaciones para mostrar.", lang)}
              </Typography>
            )}

            {Object.entries(resumenAgrupado).map(([team, usuarios]) => (
              <Box key={team} sx={{ mb: 2 }}>
                <Typography
                  variant='subtitle1'
                  sx={{ fontWeight: "bold", color: MUI_COLORS.PRIMARY }}>
                  {team}
                </Typography>
                {Object.entries(usuarios).map(([usuario, mos]) => {
                  const userInfo = usuariosTaller.find(
                    (u) => u.name === usuario
                  );
                  const totalMin = userInfo?.minutosefectivosdia ?? 0;
                  const gastadoHoy = asignadoHoyPorUsuario[usuario] || 0;

                  return (
                    <Box key={usuario} sx={{ ml: 2, mb: 1 }}>
                      <AppButton
                        variantType='secondary'
                        sx={{
                          textTransform: "none",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                        onClick={() =>
                          setExpandedUser(
                            expandedUser === `${team}_${usuario}`
                              ? null
                              : `${team}_${usuario}`
                          )
                        }>
                        <span>
                          {usuario} ({mos.length})
                        </span>
                        <span>
                          {gastadoHoy}/{totalMin} min
                        </span>
                      </AppButton>

                      {expandedUser === `${team}_${usuario}` && (
                        <Box sx={{ ml: 2 }}>
                          {mos
                            .sort((a, b) => {
                              const ordenEstado = {
                                activo_hoy: 0,
                                activo_anterior: 1,
                                finalizado: 2,
                              };

                              if (
                                ordenEstado[a.estado] !== ordenEstado[b.estado]
                              ) {
                                return (
                                  ordenEstado[a.estado] - ordenEstado[b.estado]
                                );
                              }

                              const fechaA = new Date(a.fecha_asignacion);
                              const fechaB = new Date(b.fecha_asignacion);
                              return fechaB - fechaA;
                            })
                            .map((mo, index) => (
                              // <Box
                              //   key={`${mo.id}_${index}`}
                              //   onClick={() => handleSubmitCode(mo)}
                              //   sx={{
                              //     display: "flex",
                              //     justifyContent: "space-between",
                              //     alignItems: "center",
                              //     px: 1,
                              //     py: 0.5,
                              //     borderBottom: `1px solid ${BORDER_COLORS.SECONDARY}`,
                              //     background: "#fafafa",
                              //     mb: 1,
                              //     borderRadius: 1,
                              //     cursor: "pointer",
                              //     "&:hover": {
                              //       backgroundColor: "#e8e8e8",
                              //     },
                              //   }}>
                              //   <Typography
                              //     variant='body2'
                              //     sx={{ fontWeight: "bold" }}>
                              //     {mo.mo}
                              //   </Typography>
                              //   {renderEstadoMo(mo)}
                              //   <Typography
                              //     variant='body2'
                              //     sx={{ color: "#174045" }}>
                              //     {extraerMinutos(mo.duracion)} min
                              //   </Typography>
                              // </Box>
                              <Box
                                key={`${mo.id}_${index}`}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: 1,
                                }}>
                                {mo.estado !== "finalizado" && (
                                  <IconButton
                                    size='small'
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      finalizarMoManualmente(mo);
                                    }}
                                    sx={{
                                      color: STATUS_COLORS.ERROR,
                                      minWidth: "auto",
                                      width: 24,
                                      height: 24,
                                      mr: 1,
                                    }}>
                                    <CloseIcon fontSize='small' />
                                  </IconButton>
                                )}

                                {/* El resto del contenido clickeable */}
                                <Box
                                  onClick={() => handleSubmitCode(mo)}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    flex: 1,
                                    cursor: "pointer",
                                  }}>
                                  <Typography
                                    variant='body2'
                                    sx={{ fontWeight: "bold" }}>
                                    {mo.mo}
                                  </Typography>
                                  {renderEstadoMo(mo)}
                                  <Typography
                                    variant='body2'
                                    sx={{ color: MUI_COLORS.PRIMARY }}>
                                    {extraerMinutos(mo.duracion)} min
                                  </Typography>
                                </Box>
                              </Box>
                            ))}
                        </Box>
                      )}
                    </Box>
                  );
                })}
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </AppDialog>
  );
}
